import axios from 'axios'
import Vue from 'vue'
let axiosAccess = axios.create({
    baseURL: 'https://apodaca.rciempaquesplegadizos.com:8180/',
    
    headers: {
        
        'Content-Type': 'application/json',
       
      },
  })

export async function reporteDia (context,payload){
    try{
    let url = "access/reporteorden/_por_dia"//la direccion de la api
    context.commit('setLoading',true,{root:true}) //lanzamos el loading
    context.commit('flushReporte')//se limpia el storage
    let values = new FormData()
    values.append('orden',payload.orden)
    values.append('dia',payload.dia)  
    values.append('token','Rmk2c2pZa3o2bDExM0dCUWdib1I=')
    let response = await axiosAccess({
        method: 'POST',
        url: url,
        data: values
    })
    context.commit('setReporte',response.data.data)
    }catch(error){
        context.commit('setError', error)
    }
    finally{
        context.commit('setLoading',false,{root:true})
    }
}
export async function reporteSemana (context,payload){
    try{
        let url = "access/reporteorden/_por_semana"//la direccion de la api
        context.commit('setLoading',true,{root:true}) //lanzamos el loading
        context.commit('flushReporte')//se limpia el storage
        let values = new FormData()
        values.append('orden',payload.orden)
        values.append('semana',payload.semana)  
        values.append('token','Rmk2c2pZa3o2bDExM0dCUWdib1I=')
        let response = await axiosAccess({
            method: 'POST',
            url: url,
            data: values
        })
        context.commit('setReporte',response.data.data)
        }catch(error){
            context.commit('setError', error)
        }
        finally{
            context.commit('setLoading',false,{root:true})
        }
}
export async function reporteMes(context,payload){
    try{
        let url = "access/reporteorden/_por_mes"//la direccion de la api
        context.commit('setLoading',true,{root:true}) //lanzamos el loading
        context.commit('flushReporte')//se limpia el storage
        let values = new FormData()
        values.append('orden',payload.orden)
        values.append('mes',payload.mes)  
        values.append('anno',payload.anno)
        values.append('token','Rmk2c2pZa3o2bDExM0dCUWdib1I=')
        let response = await axiosAccess({
            method: 'POST',
            url: url,
            data: values
        })
        context.commit('setReporte',response.data.data)
    }catch(error){
        context.commit('setError', error)
    }
    finally{
        context.commit('setLoading',false,{root:true})
    }
}
export async function reporteAnno(context,payload){
    try{
        let url = "access/reporteorden/_por_anno"//la direccion de la api
        context.commit('setLoading',true,{root:true}) //lanzamos el loading
        context.commit('flushReporte')//se limpia el storage
        let values = new FormData()
        values.append('orden',payload.orden)
        values.append('anno',payload.anno)
        values.append('token','Rmk2c2pZa3o2bDExM0dCUWdib1I=')
        let response = await axiosAccess({
            method: 'POST',
            url: url,
            data: values
        })
        context.commit('setReporte',response.data.data)
    }catch(error){
        context.commit('setError', error)
    }
    finally{
        context.commit('setLoading',false,{root:true})
    }
}